// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".text-wrapper[data-v-fe3c4b30]{background-repeat:no-repeat;background-position-y:100%;background-size:contain}", ""]);
// Exports
module.exports = exports;
